/**
 * Live Quiz Player Screen
 * Entry point for team players joining a live quiz session
 */

import React, { useCallback } from "react";
import { useLocalSearchParams } from "expo-router";
import { router } from "expo-router";
import { useFocusEffect } from "@react-navigation/native";
import { LiveQuizScreen } from "@/modules/quiz-live";

/**
 * Live Quiz Route for mobile players
 */
export default function LiveQuizRoute() {
  const params = useLocalSearchParams<{ sessionId?: string; spectator?: string }>();
  const sessionId = params.sessionId || "";
  const spectatorMode = params.spectator === "true";

  /**
   * Handle exit — replace this route with /games on the Spellen tab stack so
   * the dead /quiz/live screen doesn't get cached, then navigate to home.
   */
  const handleExit = () => {
    router.replace("/(tabs)/games" as any);
    setTimeout(() => router.navigate("/(tabs)" as any), 0);
  };

  // Safety net: if this screen gains focus without a sessionId (e.g. stale
  // tab state or deep-link edge case), redirect to the games overview.
  useFocusEffect(
    useCallback(() => {
      if (!sessionId) {
        router.replace("/(tabs)/games" as any);
      }
    }, [sessionId])
  );

  if (!sessionId) {
    return null;
  }

  return (
    <LiveQuizScreen
      sessionId={sessionId}
      spectatorMode={spectatorMode}
      onExit={handleExit}
    />
  );
}

